import React from 'react';

export type SortIconProps = { state: 'none' | 'asc' | 'desc'; className?: string };

export function SortIcon({ state, className }: Readonly<SortIconProps>) {
  const base = `inline-block align-middle ${className || ''}`.trim();
  if (state === 'asc') {
    return (
      <svg data-testid="sort-icon" aria-label="Aufsteigend sortiert" viewBox="0 0 20 20" fill="currentColor" width="1em" height="1em" className={base}>
        <path d="M10 4l-6 6h12l-6-6z" />
      </svg>
    );
  }
  if (state === 'desc') {
    return (
      <svg data-testid="sort-icon" aria-label="Absteigend sortiert" viewBox="0 0 20 20" fill="currentColor" width="1em" height="1em" className={base}>
        <path d="M10 16l6-6H4l6 6z" />
      </svg>
    );
  }
  return (
    <svg data-testid="sort-icon" aria-hidden="true" viewBox="0 0 20 20" fill="currentColor" width="1em" height="1em" className={base}>
      <path d="M10 4l-4 4h8l-4-4zM10 16l4-4H6l4 4z" />
    </svg>
  );
}
